import * as React from 'react'

import { ViolationModel } from 'app/models'
import { BaseEventModel } from 'app/models/baseEventModel'
import { getViolationName } from 'app/services/violation/violationNameResolver'
import { formatDateTime } from 'app/common/dateHelper'

import { useScene } from '../context/SceneContext'
import { useConfig } from '../context/ConfigContext'

export type ViolationBlockProps = {
  violation: ViolationModel
  index: number
  offsetX?: number
}

const color = '#BA7042'

export const VIOLATION_BADGE_OFFSET_X = 17

export const violationBadgeWidth = (index: number): number =>
  index + 1 >= 10 ? 17 : 14

export const hasViolationMarker = (
  violation: ViolationModel,
  sceneStartTime: any,
): boolean =>
  formatDateTime(violation.startTime) !=
  formatDateTime(sceneStartTime.clone().add(1, 'days'))

export const ViolationBlock: React.FC<ViolationBlockProps> = React.memo(
  (props: ViolationBlockProps) => {
    const scene = useScene()
    const { onViolationSelected, printMode } = useConfig()

    const violation = props.violation

    const prepareTooltipInfo = (): BaseEventModel => {
      const info: BaseEventModel = {
        startTime: violation.startTime,
        endTime: violation.endTime,
        typeName: getViolationName(violation.type),
        color: color,
      }
      return info
    }

    const width = scene.widthOf(violation.startTime, violation.endTime)
    const position = scene.timeToX(violation.startTime)

    // The badge number indexes the on-screen violation list; a printout has no such list.
    const shouldDisplayViolationMarker =
      !printMode && hasViolationMarker(violation, scene.startTime)

    const wider = props.index + 1 >= 10
    const offsetX = props.offsetX ?? 0

    return (
      <div
        className="tw-flex tw-flex-col tw-justify-end"
        style={{
          left: position,
          top: 0,
          bottom: 0,
          position: 'absolute',
          width: 50,
        }}
      >
        {shouldDisplayViolationMarker && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: -8 + offsetX,
              zIndex: 500,
            }}
          >
            <svg
              width="50"
              height="50"
              style={{ pointerEvents: 'none' }}
            >
              <rect
                width={wider ? '17' : '14'}
                height="14"
                x="25"
                y="0"
                onClick={() => onViolationSelected && onViolationSelected()}
                data-tip={JSON.stringify(prepareTooltipInfo())}
                data-for="eventTooltip"
                style={{ fill: color, cursor: 'pointer', pointerEvents: 'all' }}
              />
              <text
                x={wider ? '26' : '29'}
                y="11"
                onClick={() => onViolationSelected && onViolationSelected()}
                data-tip={JSON.stringify(prepareTooltipInfo())}
                data-for="eventTooltip"
                style={{
                  fontSize: 12,
                  fontWeight: 500,
                  textAlign: 'center',
                  fill: '#FFFFFF',
                  cursor: 'pointer',
                  pointerEvents: 'all',
                }}
              >
                {props.index + 1}
              </text>
            </svg>
          </div>
        )}
        <div
          style={{
            background: color,
            borderColor: '#000000',
            position: 'absolute',
            width,
            height: 3,
         
            top: -3,
          }}
        />
      </div>
    )
  },
)

ViolationBlock.displayName = 'ViolationBlock'
